



import { useState } from "react"
import { useDispatch } from "react-redux"
import styled from "styled-components"
import { updateRouteItem } from "../../../../../features/updateLoad/updateLoadSlice"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import dateConverter from "../../../../../helper/dateConverter"

const Container = styled.div`
    width: 220px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme, isActive, isError}) => isError ? "var(--color-red)" : isActive? "#E85446" : theme.mainBorderColor};
        border-color: ${({showErrors}) => showErrors && "var(--color-red)"};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }

        &::-webkit-calendar-picker-indicator{
          filter: ${({theme})=> theme.inputDateIconColor};
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({showErrors}) => showErrors && "var(--color-red)"};

    }
`

const YuklemeDateInput = ({data, isRequired, name}) => {

    const [text, setText] = useState(data.date)
    const [isError, setIsError] = useState(false)
    const {showErrors, showRequiredPlaces} = useSelector(state => state.updateLoad)
    const dispatch = useDispatch()

    useEffect(()=> {
        setText(data.date)
    },[data.date])

    const handleChange = (e) => {
        setText(e.target.value)

        const updatedItem = {
            id: data.id,
            date: e.target.value
        }
        dispatch(updateRouteItem(updatedItem))
    }

    useEffect(() => {
        //! bu submit esnasında boş girerse gösterilecek 
        if(isRequired && !data.date && showErrors){
            return setIsError(true)
        }
        //! bu kullanıcı zorunlu alanları görüntülemek isterse
        if(isRequired && showRequiredPlaces){
           return setIsError(true)
        }
        else{
            setIsError(false)
        }
    },[isRequired, data.date, showRequiredPlaces, showErrors])


  return (
    <Container value={text} radius={"5px"} isError={isError}>
        <input type="date" id={"text"} onChange={handleChange} value={dateConverter(text, "us")} name={name}/> 
        <label htmlFor={"text"}>Yükleme Tarihi{isRequired && "*"} </label>
    </Container>
  )
}

export default YuklemeDateInput